(function() {
  'use strict';

  angular
    .module('app', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'stringFilters']);

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('tile', tile);

  /** @ngInject */
  function tile() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/tile/tile.html',
      scope: {
      },
      link : tileLink,
      controller: tileController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function tileController() {
      var vm = this;
    }

    function tileLink(scope, element, attrs, controller, transcludeFn) {
    
    }
  }

})();

(function() {
  'use strict';

  angular
      .module('app')
      .service('wpJson', wpJson);

  /** @ngInject */
  function wpJson( $http, $q, $rootScope ) {

    var tags = [],
        categories = [];

    initTags();



    this.getProjects = function(){

      var deferred = $q.defer();

      $http({
        method: 'GET',
        url: $rootScope.apiPath + '/wp-json/wp/v2/projects',
        params: {
          'per_page': 28
        }
      }).then(function( response ){
        console.log('projects done');
        return deferred.resolve( response.data );

      });

      return deferred.promise;

    };

    this.getPosts = function(){

      var deferred = $q.defer();

      $http({
        method: 'GET',
        url: $rootScope.apiPath + '/wp-json/wp/v2/posts',
        params: {
          'per_page': 28
        }
      }).then(function( response ){
        console.log('posts done');
        return deferred.resolve( response.data );

      });

      return deferred.promise;

    };

    // pass in array of tag ids
    this.getTags = function( array ) {

      var deferred = $q.defer();
      var picked;
      var results = _.filter( tags, function( tag ){
        return _.includes( array, tag.id);
      });

      deferred.resolve( results );

      return deferred.promise;

    };

    // pass in array of category ids
    this.getCategories = function( array ) {

      var deferred = $q.defer();
      var picked;
      var results = _.filter( categories, function( category ){
        return _.includes( array, category.id);
      });

      deferred.resolve( results );

      return deferred.promise;

    };

    this.getSinglePost = function( slug ) {
        var deferred = $q.defer();

        $rootScope.loading = true;

        $http({
            method: 'GET',
            url: $rootScope.apiPath + '/wp-json/wp/v2/posts',
            params: {
                slug: slug
            }
        }).then(function( response ){
            $rootScope.loading = false;
            return deferred.resolve( response.data );
        });

        return deferred.promise;
    };

    this.getSingleProject = function( slug ) {
        var deferred = $q.defer();

        $rootScope.loading = true;

        $http({
            method: 'GET',
            url: $rootScope.apiPath + '/wp-json/wp/v2/projects?_embed',
            params: {
                slug: slug
            }
        }).then(function( response ){
            console.log('GOT SINGLE PROJECT');
            $rootScope.loading = false;
            return deferred.resolve( response.data );
        });

        return deferred.promise;
    };

    this.getRelatedArticles = function( type, categories, postID ) {
        var deferred = $q.defer();


        $http({
            method: 'GET',
            url: $rootScope.apiPath + '/wp-json/wp/v2/' + type +'s',
            params: {
                categories: categories,
                exclude: postID
            }
        }).then(function( response ){

            return deferred.resolve( response.data );
        });

        return deferred.promise;
    };

    // for manual related articles
    // pass in array of post/project ids
    this.convertRelatedArticles = function( type, ids ) {
        var deferred = $q.defer();

        console.log(ids);

        $http({
            method: 'GET',
            url: $rootScope.apiPath + '/wp-json/wp/v2/any',
            params: {
                ids : JSON.stringify(ids)
            }
        }).then(function( response ){

            console.log(response);
            return deferred.resolve( response.data );
        });

        return deferred.promise;
    };


    function initTags() {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        url: $rootScope.apiPath + '/wp-json/wp/v2/tags'
      }).then(function( response ){

        tags = response.data;

      });
    }

    this.initCategories = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        url: $rootScope.apiPath + '/wp-json/wp/v2/categories'
      }).then(function( response ){

        categories = response.data;

        return deferred.resolve( response.data );

      });

      return deferred.promise;
    }

    this.getPage = function ( slug ) {
        var deferred = $q.defer();

        $http({
            method: 'GET',
            url: $rootScope.apiPath + '/wp-json/wp/v2/pages',
            params: {
                slug: slug
            }
        }).then(function( response ){
            return deferred.resolve( response.data[0] );
        });

        return deferred.promise;
    }



  }





})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('PostController', PostController);

  /** @ngInject */
  function PostController( $rootScope, $scope, $state, $stateParams, wpJson, $q ) {

    var vm = this;
    var promise;

    vm.expanded = false;
    vm.data = {};
    vm.similarArticles = [];


    promise = wpJson.getSingleProject( $stateParams.slug );

    $scope.$emit('filters.reset');

    // get single post
    promise.then(function(data){
        console.log('got post!');
        console.log(data[0]);


        vm.data = data[0];
        vm.title = vm.data.title.rendered;
        vm.intro = vm.data.acf.intro;
        vm.body = vm.data.content.rendered;
        vm.images = vm.data.acf.image_group;
        vm.date = vm.data.date;
        vm.type = vm.data.acf.article_type;
        vm.relatedPosts = vm.data.acf.related_posts;
        vm.credits = vm.data.acf.project_credits;
        vm.author = vm.data._embedded.author[0].name;

        //$scope.$parent.type = vm.type;
        $scope.$emit('categories.check', { categories: vm.data.categories, type: vm.type });

        try {
            vm.featuredImage = vm.data.better_featured_image.media_details.sizes.featured.source_url;
        } catch(error) {
            vm.featuredImage = vm.data.better_featured_image.media_details.sizes.medium.source_url;
        }

        if ( $rootScope.ready ) {
            prepRelatedArticles();
        } else {
            $scope.$on('app.ready', prepRelatedArticles);
        }


        vm.extraInfo = {
            header: vm.data.acf.extra_information_header,
            fields: vm.data.acf.extra_information
        };



        wpJson.getTags( vm.data.tags ).then(function( tags ){
            vm.tags = tags;
        });

        vm.showReadMore();

    });



    this.expandText = function() {
        console.log('expand text');
        vm.expanded = true;
    };

    this.showReadMore = function() {
        console.log( document.getElementsByClassName('post__body')[0].offsetHeight );
         return document.getElementsByClassName('post__body')[0].offsetHeight > 299;
    };

    this.empty = function( object ) {
        return _.isEmpty(object);
    }



    function prepRelatedArticles() {
        if ( typeof vm.relatedPosts == 'undefined' || vm.relatedPosts == '') {
            console.log('get auto related articles');

            getAutoRelatedArticles(4);

        } else {

            var ids = _.map( vm.relatedPosts, 'ID' );

            getManualRelatedArticles( ids );
        }
    }

    function getAutoRelatedArticles( limit ) {


        var postsWithoutCurrent = _.reject( $rootScope.combined, { id: vm.data.id } );

        var result = _.filter( postsWithoutCurrent, function( article ) {
            var catResult = _.intersection( vm.data.categories, article.category_ids );
            var tagResult = _.intersection( vm.data.tags, article.tag_ids );

            return catResult.length > 0 || tagResult > 0;
        });

        if (limit < 4 ) {
            vm.relatedPosts = _.union( vm.relatedPosts, result );
        }

        vm.relatedPosts = _.take( result, 4 );

    }

    function getManualRelatedArticles( postIDs ) {

        vm.relatedPosts = _.filter( $rootScope.combined, function( article ){
            return _.includes( postIDs, article.id );
        });

        console.log(vm.relatedPosts);

        vm.relatedPosts = _.take( vm.relatedPosts, 4 );




    }


  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $timeout, wpJson, $state, $rootScope, $stateParams ) {
    var vm = this;

    vm.projects = [];
    vm.posts = [];
    vm.combined = [];


    console.log('main');

    //console.log( $stateParams );

    //vm.combined = $scope.$parent.combined;

    $scope.loaded = false;


    $scope.filter = function() {

    }




  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AboutController', AboutController);

  /** @ngInject */
  function AboutController($rootScope, $scope, wpJson) {

    var vm = this;

    vm.section = 'profile';
    $rootScope.loading = true;

    $scope.$emit('filters.reset');

    this.doThis = function( section ){

        var destination;

        vm.section = section;
        destination = $('#'+section).offset().top - $('.hdr').outerHeight();

        TweenMax.to( window, 1, { scrollTo: { y: destination }, ease: Quart.easeInOut  });
    };

    wpJson.getPage('about').then(function( response ){
        console.log( response );
        $rootScope.loading = false;
        vm.address = response.acf.address;
        vm.email = response.acf.email;
        vm.phone = response.acf.phone;
        vm.summary = response.acf.summary;

        vm.profile = {
            image: response.better_featured_image.source_url,
            content: response.content.rendered
        };

        vm.practice = {
            content: response.acf.practice_content
        };

        vm.clients = response.acf.clients.split('<br />');

        vm.founders = {
            image: response.acf.founders_image,
            caption: response.acf.founders_caption,
            content: response.acf.founders_content
        };

        vm.victor = {
            cv: response.acf.cv.split('<br />'),
            education: response.acf.education.split('<br />')
        }

        vm.jac = {
            cv: response.acf.cv_jac.split('<br />'),
            education: response.acf.education_jac.split('<br />')
        }

        vm.awards = response.acf.awards;
        vm.forums = response.acf.forums;

        var staff = response.acf.staff_members.split('<br />');
        var chunked = _.chunk( staff, Math.ceil( staff.length/2 ) );

        vm.staff1 = chunked[0];
        vm.staff2 = chunked[1];








    });


  }




})();

(function() {
  'use strict';

  angular
    .module('app')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope) {

    $log.debug('runBlock end');

    $rootScope.ready = false;

    if ( window.location.host.split(':')[0] == 'localhost' ) {
        $rootScope.apiPath = 'http://ply.dev';
    } else {
        $rootScope.apiPath = 'http://ply-studio.com/staging/cms';
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        params: { tag:  '' },
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('post', {
        url: '/post/:slug',
        params: { id:  null },
        templateUrl: 'app/post/post.html',
        controller: 'PostController',
        controllerAs: 'post'
      })
      .state('project', {
        url: '/project/:slug',
        params: { id:  null },
        templateUrl: 'app/post/post.html',
        controller: 'PostController',
        controllerAs: 'post'
      })
      .state('about', {
        url: '/about',
        templateUrl: 'app/about/about.html',
        controller: 'AboutController',
        controllerAs: 'about'
      })
    $urlRouterProvider.otherwise('/');
  }

})();

(function() {
  'use strict';

  angular
    .module('stringFilters', [])
    .filter('slugify', function() {
      return function(input) {
        var newString = input.replace(/ /g, '-').toLowerCase();
        return newString;
      }
    })
    .filter('deslugify', function() {
      return function(input) {
        if (!input || !input.length) { return; }
        var newString = input.replace('-', ' ');
        return newString;
      }
    })
    .filter('capitalize', function() {
        return function(input) {
          return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
        }
    })
    .filter('words', function () {
        return function (input, words) {
            if (isNaN(words)) return input;
            if (words <= 0) return '';
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + ' […]';
                }
            }
            return input;
        };
    })
    .filter('htmlToPlainText', function() {
        return function(text) {
          return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
        };
    });

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('IndexController', IndexController)
    .directive('scroll', scroll);

  /** @ngInject */
  function IndexController($rootScope, $scope, $state, $stateParams, wpJson, $window ) {
    var vm = this,
        filterInitiated = false;

    $scope.activated = false;
    $scope.$state = $state;
    $scope.filterMode = 'category' // `category` or `type`
    $scope.filters = [ 'simple-geometry', 'modulated-forms', 'material-logic', 'types-convention' ];
    $scope.type = '';
    $scope.tagFilter = '';
    $scope.$state = $state;

    vm.minHeight = $window.innerHeight - $('.ftr').outerHeight() - $('.hdr').outerHeight();

    $rootScope.$on('$stateChangeSuccess', function( s, p ) {
        console.log($stateParams);
        if ( $stateParams.tag !== '' ) {

            $scope.selectTag( $stateParams.tag );
        } else {
            $scope.filterMode = 'category';
            vm.activeCategories = [];
        }
    });

    activate();


    wpJson.initCategories().then(function( categories ){
        $scope.categories = categories;
    });

    $scope.$on('categories.check', function( event, params ){
        console.log('check');
        $scope.currentPostType = params.type;
        vm.activeCategories = params.categories;
    });

    vm.isActiveCategory = function( id ) {

        return _.includes( vm.activeCategories, id );
    };


    // unused
    $scope.containsCategoryOrType = function( item ) {
        var result;

        if ( $scope.filterMode == 'category' ) {
            result = _.intersection($scope.filters, item.categories);
            return result.length > 0;
        } else {
            //console.log( $scope.types );
            return item.type == $scope.types;
        }
    }

    $scope.containsCategoryOrTag = function( item ) {
        var result;

        if ( $scope.filterMode == 'category' ) {

            result = _.intersection($scope.filters, item.categories);

            if ( $scope.type !== '' ) {
                return result.length > 0 && item.acf.article_type == $scope.type;
            } else {
                return result.length > 0;
            }


        } else if ( $scope.filterMode == 'tag' ) {

            var itemTagNames = _.map( item.tags, 'slug' );
            result = _.includes(itemTagNames, $scope.tagFilter );

            return result;
        }
    }

    $scope.selectTag = function( tag ) {
        //console.log( tag );
        $scope.filterMode = 'tag';
        $scope.tagFilter = tag;
    };

    $scope.selectType = function( type ) {
        $scope.type = type;
        $scope.currentPostType = $scope.type;
        if ( !$state.is('home') ) {
            $state.go('home');
        }
        //$scope.filterMode = 'type';
        //console.log( type );
    };


    $scope.isLoading = function() {

        return !$rootScope.ready || $rootScope.loading;
    }

    // $scope.toggleFilter = function( category ) {

    //   if ( !filterInitiated ) {
    //     $scope.filters = [];
    //     filterInitiated = true;
    //   }

    //   if ( _.includes( $scope.filters, category ) ) {
    //     $scope.filters = _.without( $scope.filters, category );
    //   } else {
    //     $scope.filters.push( category );
    //   }

    // }

    function activate() {
      getPostsProjects();
    }



    function getPostsProjects() {

      var promise = wpJson.getProjects();


      promise.then(function(data) {


        vm.projects = data;

        $rootScope.combined = vm.projects;


        //$rootScope.combined = _.orderBy( $rootScope.combined, [ 'date' ], [ 'desc' ] );

        //console.log(vm.combined);

        _.each( $rootScope.combined, function( tile, key ){

          tile.category_ids = tile.categories;
          tile.tag_ids = tile.tags;
          tile.type = tile.acf.article_type;

          wpJson.getTags( tile.tags ).then(function( response ){
            tile.tags = response;
          });

          wpJson.getCategories( tile.categories ).then(function( response ){
            tile.categories = _.map(response, 'slug');
          });

          if ( tile.acf.tile_thumbnail == '' || typeof tile.acf.tile_thumbnail == 'undefined' ) {
            tile.thumb = tile.better_featured_image.media_details.sizes.thumbnail.source_url;
          } else {
            tile.thumb = tile.acf.tile_thumbnail.sizes.thumbnail;
          }


        });

        console.log($rootScope.combined);
        $rootScope.ready = true;
        $rootScope.$broadcast('app.ready');


      });



    }

    $scope.selectCategory = function( category ) {
        $scope.filterMode = 'category';
        $scope.activated = true;
        $scope.filters = [];
        $scope.filters.push( category );

        if ( !$state.is('home') ) {
            $state.go('home');
        }

    }

    $scope.resetFilters = function(){
        console.log('RESET');
        $scope.activated = false;
        $scope.filterMode = 'category';
        $scope.filters = [ 'simple-geometry', 'modulated-forms', 'material-logic', 'types-convention' ];
        $scope.type = '';
        $scope.currentPostType = '';

    };

    $scope.$on('filters.reset', $scope.resetFilters );

    $scope.clearTagFilter = function() {
        $scope.filterMode = 'category';
        $scope.tagFilter = '';
    };

    $scope.getLink = function( tile ) {
        var urlPrefix = tile.type;

        if ( typeof tile.slug == 'undefined') {
            tile.slug = tile.post_name;
            tile.id = tile.ID;
        }

        return urlPrefix + '({ slug: "'+ tile.slug +'", id: '+ tile.id +'  })';
    };


    Array.prototype.move || Object.defineProperty(Array.prototype, "move", {
        value: function (index, howMany, toIndex) {
            var
            array = this,
            index = parseInt(index) || 0,
            index = index < 0 ? array.length + index : index,
            toIndex = parseInt(toIndex) || 0,
            toIndex = toIndex < 0 ? array.length + toIndex : toIndex,
            toIndex = toIndex <= index ? toIndex : toIndex <= index + howMany ? index : toIndex - howMany,
            moved;

            array.splice.apply(array, [toIndex, 0].concat(moved = array.splice(index, howMany)));

            return moved;
        }
    });



  }

  function scroll( $window ) {
    return function(scope, element, attrs) {

        var zoom = getZoomFactor();

        //scope.offsetX = 0;

        $($window).bind('scroll', function() {
            zoom = getZoomFactor();
            console.log($(window).scrollLeft());
            //console.log($(window).scrollLeft() * zoom);
            //scope.offsetX = -Math.round($($window).scrollLeft() * zoom)/2  + 'px';
            //element.width( 1100 );
            //scope.scrollTop = $(window).scrollTop() + 'px';
            scope.scrollTop = 0;
            scope.$apply();


        });

    };
  }

  function getZoomFactor() {
  var deviceWidth, landscape = Math.abs(window.orientation) == 90
  // workaround for strange screen.height on the iPhone (v3.1.3)
  if (window.screen.width == 320) deviceWidth = landscape ? 480 : 320
  else deviceWidth = window.screen[landscape ? "height" : "width"]
  return deviceWidth / $('body').outerWidth()
}

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('app')

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config);

  /** @ngInject */
  function config($logProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

  }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/about/about.html","<div class=\"row abt fade\" ng-hide=loading><div class=col--3><ul class=\"list--reset abt__submenu\"><li class=abt__submenu__item><a class=abt__submenu__link ng-class=\"{\'active\': about.section == \'profile\'}\" ng-click=\"about.doThis(\'profile\')\" href=\"\">Profile</a></li><li class=abt__submenu__item><a class=abt__submenu__link ng-class=\"{\'active\': about.section == \'practice\'}\" ng-click=\"about.doThis(\'practice\')\" href=\"\">Practice</a></li><li class=abt__submenu__item><a class=abt__submenu__link ng-class=\"{\'active\': about.section == \'founders\'}\" ng-click=\"about.doThis(\'founders\')\" href=\"\">Founders</a></li><li class=abt__submenu__item><a class=abt__submenu__link ng-class=\"{\'active\': about.section == \'staff\'}\" ng-click=\"about.doThis(\'staff\')\" href=\"\">Past and current interns &amp; staff</a></li><li class=abt__submenu__item><a class=abt__submenu__link ng-class=\"{\'active\': about.section == \'clients\'}\" ng-click=\"about.doThis(\'clients\')\" href=\"\">Client list</a></li><li class=abt__submenu__item><a class=abt__submenu__link ng-class=\"{\'active\': about.section == \'awards\'}\" ng-click=\"about.doThis(\'awards\')\" href=\"\">Awards, forum &amp; exhibitions</a></li></ul></div><div class=col--9><div class=row><div class=\"col--8 abt__block\"><section id=profile><h3>Profile</h3><img ng-src=\"{{ about.profile.image }}\" alt=Profile><div ng-bind-html=about.profile.content></div></section><section id=practice><h3>Practice</h3><div ng-bind-html=about.practice.content></div></section></div><div class=\"col--4 abt__sidecontent\"><div><h5>OFFICE</h5><p ng-bind-html=about.address></p><p>{{ about.phone }}<br><a class=t--white href=\"mailto:{{ about.email }}\">{{ about.email }}</a></p><div ng-bind-html=about.summary></div></div></div></div><div class=row><div class=\"col--8 abt__block\"><section id=founders><h3>Founders</h3><div class=h-clearfix><img class=abt__founders ng-src=\"{{ about.founders.image }}\"><div class=abt__founders__caption ng-bind-html=about.founders.caption></div></div><br><div ng-bind-html=about.founders.content></div></section><section id=staff><h3>Past and Current<br>Interns &amp; Staff</h3><ul class=\"list--reset abt__staff__list\"><li ng-repeat=\"staff1 in about.staff1\">{{ staff1 }}</li></ul><ul class=\"list--reset abt__staff__list\"><li ng-repeat=\"staff2 in about.staff2\">{{ staff2.trim() }}</li></ul></section><section id=clients><h3>Client list</h3><ul class=\"list--reset abt__staff__list\"><li ng-repeat=\"client in about.clients\">{{ client.trim() }}</li></ul></section><section id=awards><h3>Awards</h3><ul class=list--reset><li class=abt__awards__item ng-repeat=\"award in about.awards\"><span class=abt__awards__year>{{ award.award_year }}</span><div class=abt__awards__detail ng-bind-html=award.award_name></div></li></ul></section><section id=forums><h3>Forums &amp; Exhibitions</h3><ul class=list--reset><li class=abt__awards__item ng-repeat=\"forum in about.forums\"><span class=abt__awards__year>{{ forum.forum_year }}</span><div class=abt__awards__detail ng-bind-html=forum.forum_name></div></li></ul></section></div><div class=col--4><div class=\"abt__sidecontent abt__people\"><h5>VICTOR LEE</h5><ul class=\"list--reset abt__resume__list\"><li ng-repeat=\"item in about.victor.cv\">{{ item.trim() }}</li></ul><strong>Education</strong><br><ul class=\"list--reset abt__resume__list abt__resume__list--education\"><li ng-repeat=\"education in about.victor.education\">{{ education.trim() }}</li></ul><br><h5>JACQUELINE YEO</h5><ul class=\"list--reset abt__resume__list\"><li ng-repeat=\"jacItem in about.jac.cv\">{{ jacItem.trim() }}</li></ul><strong>Education</strong><br><ul class=\"list--reset abt__resume__list abt__resume__list--education\"><li ng-repeat=\"jacEducation in about.jac.education\">{{ jacEducation.trim() }}</li></ul></div></div></div></div></div>");
$templateCache.put("app/main/main.html","<div class=tiles--home><div class=tiles__filter ng-show=\"filterMode == \'tag\'\"><span class=tiles__filter__item>{{ tagFilter | deslugify }}</span> <a href=\"\" ng-click=clearTagFilter() class=\"tiles__filter__close icon--x\"></a></div><div class=row><div class=\"simple-fade-in fade tile\" ng-repeat=\"tile in combined | filter: containsCategoryOrTag \"><div class=tile__header><h3><a ui-sref=\"{{ getLink( tile ) }}\" ng-bind-html=tile.title.rendered></a></h3><span class=tile__tags><a href=\"\" ng-repeat=\"tag in tile.tags\" ng-click=\"selectTag( tag.slug )\">{{ tag.name }}</a></span></div><a class=tile__thumb__link ui-sref=\"{{ getLink( tile ) }}\" ng-switch=tile.acf.text_thumbnail_mode><img ng-switch-default ng-src=\"{{ tile.thumb }}\" alt=\"\"><div class=tile__thumb__text ng-switch-when=true ng-switch=\"tile.acf.thumbnail_text.length > 0\"><div ng-switch-default class=tile__summary>{{ tile.acf.intro | htmlToPlainText | words: 14 }}</div><div ng-switch-when=true class=tile__summary ng-bind-html=tile.acf.thumbnail_text></div></div></a></div></div></div>");
$templateCache.put("app/post/post.html","<article ng-show=\"!post.empty( post.data )\" class=\"fade post\"><header class=post__header><div class=\"row post__header__title\"><div class=col--9><h1 ng-bind-html=post.title>{{ post.title }}</h1><div class=post__meta><span class=post__date>{{ post.date | date: \'longDate\' }}</span><br><span class=post__author>By {{ post.author }}</span></div></div><div class=col--3><div ng-if=\"post.tags.length > 0\" class=post__tags>Tags<br><a ui-sref=\"home({ tag: tag.slug })\" ng-repeat=\"tag in post.tags\">{{ tag.name }}<br></a></div></div></div><div class=row><div class=\"col--9 d--border\"><h2 ng-bind-html=post.intro>{{ post.intro }}</h2></div><div ng-if=\"post.type == \'project\' && post.extraInfo.fields !== \'0\'\" class=\"col--3 d--border post__facts\"><h4 ng-bind-html=\"post.extraInfo.header | uppercase\"></h4><p ng-repeat=\"field in post.extraInfo.fields\"><span class=post__facts__field>{{ field.name }}</span> <span class=post__facts__value>{{ field.value }}</span></p></div></div></header><img class=\"post__image post__image--featured\" ng-src=\"{{ post.featuredImage }}\" alt=\"\"><div class=row><div class=col--3><div class=post__caption>{{ post.data.better_featured_image.caption }}</div></div><div class=\"col--6 d--border post__body\" ng-class=\"{ \'is-expanded\' : post.expanded }\"><div ng-bind-html=post.body>{{ post.body }}</div><div ng-init=post.showReadMore() class=post__more ng-class=\"{ \'is-expanded\' : post.expanded }\"><a href=\"\" ng-click=post.expandText() class=post__more__btn>Read more&hellip;</a></div></div><div ng-if=\"post.type == \'project\' && post.credits !== \'0\' \" class=\"col--3 d--border post__credits\"><p ng-repeat=\"credit in post.credits\"><span class=post__credits__header ng-bind-html=credit.name></span> {{ credit.value }}</p></div></div><div class=row ng-if=\"post.images !== \'0\'\" ng-repeat=\"imageGroup in post.images\"><div class=\"col--3 d--border\"><div class=post__caption ng-bind-html=imageGroup.caption>{{ imageGroup.caption }}</div></div><div class=\"col--9 d--border\"><img ng-repeat=\"image in imageGroup.images\" class=post__image ng-src=\"{{ image.sizes.large }}\" alt=\"\"></div></div></article><div ng-show=\"!post.empty( post.data )\" class=row><div class=post__others><h2>Related Projects and Posts</h2><div ng-repeat=\"article in post.relatedPosts\" class=\"simple-fade-in tile\"><div class=tile__header><h3><a ui-sref=\"{{ getLink( article ) }}\" ng-bind-html=article.title.rendered>{{ article.title.rendered }}</a></h3><span class=tile__tags><a ng-repeat=\"tag in article.tags\" ui-sref=\"home({tag: tag.slug})\">{{ tag.name }}</a></span></div><a ui-sref=\"{{ getLink( article ) }}\"><img ng-src=\"{{ article.better_featured_image.media_details.sizes.thumbnail.source_url }}\" alt=\"\"></a></div></div></div>");
$templateCache.put("app/post/project.html","<article class=post><header class=post__header><div class=row><div class=col--9><h1>This is an example of a project</h1><span class=post__date>June 28th, 2014</span></div><div class=col--3><div class=post__tags>Tags<br><a href=\"\">Retail</a><br><a href=\"\">Commercial</a></div></div></div><div class=row><div class=\"col--9 d--border\"><h2><p>Seeing = Eating</p><p>Dining can no longer be a purely visceral experience but should also appeal to our visual senses.</p></h2></div><div ng-if=\"post.type == \'project\' \" class=\"col--3 d--border post__facts\"><h4>KEY FACTS</h4><p><span class=post__facts__field>Date</span> <span class=post__facts__value>2007</span></p><p><span class=post__facts__field>Client</span> <span class=post__facts__value>The Handburger</span></p><p><span class=post__facts__field>Location</span> <span class=post__facts__value>Raffles City, Singapore</span></p><p><span class=post__facts__field>Gross Floor Area</span> <span class=post__facts__value>1,000 sq ft</span></p></div></div></header><img class=\"post__image post__image--featured\" src=http://lorempixel.com/990/500/city alt=\"\"><div class=row><div class=col--3><div class=post__caption>Modulated timber furniture boxes of J-Loft</div></div><div class=\"col--6 d--border post__body\"><p>Today, any form of dining is inextricably linked to the experience of the visual. In the context of the shopping mall, our eyes are first attracted to food without even tasting it. The phenomenon of looking or seeing even before tasting or eating is especially important where footfall traffic is concerned.</p><p>The interior concept for The HandBurger focuses on the relationship between the visual and the dining experience by proposing a visual ‘diet’. Relating closely to the brand identity of the ‘handcrafted’ – the embodiment of natural, wholesome foods is translated into a spatial mix of customised tables, seating and overhead lighting structures finished in white-washed timber. Mirrors at sitting height set within a dark backdrop wall creates reflections of the dining hall allowing views of fellow diners and the consumption of colorfully presented gourmet burgers to be experienced.</p><p><strong>Plan Organisation</strong><br>The design strategy starts with the subdivision of the overall 2000 sqft unit space to house the Client’s other restaurant at the corner of a busy food and beverage shopping corridor in the mall. By introducing a diagonal subdivision wall, maximum&hellip;</p><div class=post__more ng-class=\"{ \'is-expanded\' : project.expanded }\"><a href=\"\" ng-click=project.expandText() class=post__more__btn>Read more&hellip;</a></div></div><div class=\"col--3 d--border post__credits\"><p><span class=post__credits__header>Identity & Graphics</span> Couple</p><p><span class=post__credits__header>Photos</span> Jeremy San</p></div></div><div class=row><div class=\"col--3 d--border\"><div class=post__caption>Caption lorem ipsum dolor sit amet consectura duis lorem ipsum lorem ipsum dolor sit amet consectura duis lorem ipsum</div></div><div class=\"col--9 d--border\"><img class=post__image src=http://lorempixel.com/g/990/200/city alt=\"\"></div></div><div class=row><div class=\"col--3 d--border\"><div class=post__caption>By introducing a diagonal subdivision wall, maximum sharing of kitchen spaces and services between both restaurants can be achieved, as well as opening up a visual axis across the shop to the mall, ensuring visual porosity and interaction.</div></div><div class=\"col--9 d--border\"><img class=post__image src=http://lorempixel.com/g/800/600/city alt=\"\"></div></div><div class=row><div class=\"col--3 d--border\"><div class=post__caption>Taking advantage of changing viewpoints passing by the shopfront, the visual experience oscillates between flatness and depth. A continuation of the shopfront walls and surfaces internally draw the eye towards the interior, gradually revealing furniture layers, organised parallel to the established diagonal axis.</div></div><div class=\"col--9 d--border\"><img class=post__image src=http://lorempixel.com/g/800/500/city alt=\"\"></div></div><div class=row><div class=\"col--3 d--border\"><div class=post__caption>Relating closely to the brand identity of the ‘handcrafted’ – the embodiment of natural, wholesome foods is translated into a spatial mix of customised tables, seating and overhead lighting structures finished in white-washed timber.</div></div><div class=\"col--9 d--border\"><img class=post__image src=http://lorempixel.com/g/800/550/city alt=\"\"></div></div><div class=row><div class=\"col--3 d--border\"><div class=post__caption>Caption lorem ipsum dolor sit amet consectura duis lorem ipsum lorem ipsum dolor sit amet consectura duis lorem ipsum</div></div><div class=\"col--9 d--border\"><img class=post__image src=http://lorempixel.com/g/800/560/city alt=\"\"></div></div><div class=row><div class=\"col--3 d--border\"><div class=post__caption>Caption lorem ipsum dolor sit amet consectura duis lorem ipsum lorem ipsum dolor sit amet consectura duis lorem ipsum</div></div><div class=\"col--9 d--border\"><img class=post__image src=http://lorempixel.com/g/800/571/city alt=\"\"></div></div></article><div class=row><div class=post__others><h2>Other projects</h2><div class=\"simple-fade-in tile\"><div class=tile__header><h3><a href=\"\">Competition Win for Rainbow Center</a></h3><span class=tile__tags><a href=\"\">Residential</a>, <a href=\"\">Awards</a></span></div><a ui-sref=post><img src=http://placekitten.com/400/250 alt=\"\"></a></div><div class=\"simple-fade-in tile\"><div class=tile__header><h3><a href=\"\">Competition Win for Rainbow Center</a></h3><span class=tile__tags><a href=\"\">Residential</a>, <a href=\"\">Awards</a></span></div><a ui-sref=post><img src=http://placekitten.com/400/250 alt=\"\"></a></div><div class=\"simple-fade-in tile\"><div class=tile__header><h3><a href=\"\">Competition Win for Rainbow Center</a></h3><span class=tile__tags><a href=\"\">Residential</a>, <a href=\"\">Awards</a></span></div><a ui-sref=post><img src=http://placekitten.com/400/250 alt=\"\"></a></div><div class=\"simple-fade-in tile\"><div class=tile__header><h3><a href=\"\">Competition Win for Rainbow Center</a></h3><span class=tile__tags><a href=\"\">Residential</a>, <a href=\"\">Awards</a></span></div><a ui-sref=post><img src=http://placekitten.com/400/250 alt=\"\"></a></div></div></div>");
$templateCache.put("app/components/tile/tile.html","<div class=\"simple-fade-in tile\" ng-repeat=\"project in main.projects | filter: containsCategory \"><div class=tile__header><h3><a href=\"\" ng-bind-html=project.title.rendered></a></h3><span class=tile__tags><a ng-repeat=\"tag in project.tags\" href=\"\">{{ tag.name }}</a></span></div><a ui-sref=post><img ng-src=\"{{ project.better_featured_image.media_details.sizes.thumbnail.source_url }}\" alt=\"\"></a></div>");}]);